import { dashboardURL } from '../../context/API';

// Dashboard URL utilities
export const getDashboardUrl = (token: string, role: string, hostname: string): string => {
  const isProduction = hostname.includes('kiwikrave.com');
  return isProduction
    ? `${dashboardURL}/dashboard?access_token=${token}&role=${role}`
    : `/dashboard?access_token=${token}&role=${role}`;
};

export const getRoleFromHostname = (hostname: string): string => {
  return hostname.includes('admin') ? 'admin' : 'merchant';
};

// OTP Constants
export const MAX_OTP_REQUESTS = 5;
export const RESEND_COOLDOWN = 60; // 1 minute in seconds
export const RESET_TIME = 3600; // 1 hour in seconds
